// Claim marks of the strategic view: one byte per hex in the overlay texture's claim block, from the
// snapshot's claim array (political/claims.ts reads the same array for the 3D hatch). The shader
// only needs to know that the leader's view claims the hex; the hatch takes its colour from the
// hex's owner.

import { HEX_COUNT } from '../../core/grid.ts';

export const CLAIM_MARK = 255;

/** 255 on every hex the leader's point of view claims from another state, else 0. */
export function claimMarks(claim: Uint16Array | undefined): Uint8Array {
  const out = new Uint8Array(HEX_COUNT);
  if (!claim) {
    return out;
  }

  for (let i = 0; i < HEX_COUNT; i++) {
    if (claim[i] !== 0) {
      out[i] = CLAIM_MARK;
    }
  }

  return out;
}
